// Mock data for TalentXpres clickable prototype

export const CITIES = ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Chennai", "Pune", "Remote"];

export const SKILLS_LIB = [
  "Python", "FastAPI", "Node.js", "React", "TypeScript", "PostgreSQL", "MongoDB",
  "AWS", "Kubernetes", "Docker", "Figma", "UX Research", "Design Systems",
  "Product Management", "SQL", "Data Analysis", "Machine Learning",
];

export const CANDIDATES = [
  {
    id: "c1",
    name: "Arjun Mehta",
    title: "Senior Backend Engineer",
    company: "PayLite",
    exp: 5,
    location: "Bangalore",
    skills: ["Python", "FastAPI", "PostgreSQL", "AWS", "Docker"],
    salary: 28,
    currentSalary: 22,
    availability: { status: "notice", days: 35 },
    bio: "5y building payment platforms. Serving 60-day notice at PayLite.",
    education: "B.Tech CSE, IIT Bombay",
    resume: "arjun_mehta_cv.pdf",
    completion: 92,
  },
  {
    id: "c2",
    name: "Sneha Rao",
    title: "Product Designer",
    company: "(Between jobs)",
    exp: 3,
    location: "Mumbai",
    skills: ["Figma", "UX Research", "Design Systems", "Prototyping"],
    salary: 16,
    currentSalary: 14,
    availability: { status: "immediate", days: 0 },
    bio: "Available immediately. Previously at fintech scale-up.",
    education: "B.Des, NID Ahmedabad",
    resume: "sneha_rao_folio.pdf",
    completion: 88,
  },
  {
    id: "c3",
    name: "Rahul Iyer",
    title: "DevOps Engineer",
    company: "InfraLabs",
    exp: 6,
    location: "Hyderabad",
    skills: ["Kubernetes", "Terraform", "AWS", "Docker"],
    salary: 32,
    currentSalary: 26,
    availability: { status: "notice", days: 58 },
    bio: "Platform reliability at scale. 30-day notice reducible.",
    education: "M.Tech, BITS Pilani",
    resume: "rahul_iyer.pdf",
    completion: 78,
  },
  {
    id: "c4",
    name: "Meera Nair",
    title: "Data Scientist",
    company: "Datavue",
    exp: 4,
    location: "Bangalore",
    skills: ["Python", "Machine Learning", "SQL", "Data Analysis"],
    salary: 24,
    currentSalary: 20,
    availability: { status: "notice", days: 12 },
    bio: "NLP + recommendations. 12 days left on notice.",
    education: "M.S. Data Science, IIIT Hyderabad",
    resume: "meera_nair.pdf",
    completion: 84,
  },
];

export const JOBS = [
  {
    id: "j1",
    title: "Senior Backend Engineer (Python)",
    company: "AcmeCorp Technologies",
    logo: "AC",
    location: "Bangalore",
    workMode: "hybrid",
    expMin: 3, expMax: 8,
    salaryMin: 22, salaryMax: 35,
    maxJoiningDays: 45,
    postedAgo: "2 days ago",
    applicants: 24,
    skills: ["Python", "FastAPI", "PostgreSQL", "AWS"],
    description:
      "Own payment microservices end-to-end. Lead architecture for the next-gen rails platform serving 2M+ transactions/day.",
    questions: [
      "What is your current notice period (in days)?",
      "Rate your FastAPI experience 1-10",
    ],
    match: 94,
  },
  {
    id: "j2",
    title: "Product Designer",
    company: "AcmeCorp Technologies",
    logo: "AC",
    location: "Remote",
    workMode: "remote",
    expMin: 2, expMax: 6,
    salaryMin: 12, salaryMax: 20,
    maxJoiningDays: 15,
    postedAgo: "5 days ago",
    applicants: 18,
    skills: ["Figma", "Design Systems", "UX Research"],
    description:
      "Own the design system + enterprise dashboards. Report to Head of Design.",
    questions: ["Share portfolio link", "Are you an immediate joiner?"],
    match: 88,
  },
  {
    id: "j3",
    title: "DevOps Engineer",
    company: "AcmeCorp Technologies",
    logo: "AC",
    location: "Hyderabad",
    workMode: "onsite",
    expMin: 4, expMax: 10,
    salaryMin: 25, salaryMax: 40,
    maxJoiningDays: 60,
    postedAgo: "1 day ago",
    applicants: 11,
    skills: ["Kubernetes", "Terraform", "AWS", "Docker"],
    description: "Kubernetes at scale. CI/CD, observability, cost optimization.",
    questions: ["Years running K8s in production?"],
    match: 72,
  },
  {
    id: "j4",
    title: "Data Scientist — Recommendations",
    company: "AcmeCorp Technologies",
    logo: "AC",
    location: "Bangalore",
    workMode: "hybrid",
    expMin: 3, expMax: 7,
    salaryMin: 20, salaryMax: 32,
    maxJoiningDays: 30,
    postedAgo: "3 days ago",
    applicants: 9,
    skills: ["Python", "Machine Learning", "SQL"],
    description: "Build recommendation systems for our marketplace.",
    questions: ["Portfolio / GitHub link?"],
    match: 81,
  },
];

export const APPLICATIONS = [
  { id: "a1", candidateId: "c1", jobId: "j1", stage: "shortlisted", appliedAgo: "3 days ago", match: 94 },
  { id: "a2", candidateId: "c2", jobId: "j2", stage: "interview", appliedAgo: "1 week ago", match: 91 },
  { id: "a3", candidateId: "c3", jobId: "j3", stage: "new", appliedAgo: "1 day ago", match: 72 },
  { id: "a4", candidateId: "c4", jobId: "j4", stage: "screening", appliedAgo: "2 days ago", match: 81 },
  { id: "a5", candidateId: "c2", jobId: "j1", stage: "new", appliedAgo: "4 hours ago", match: 62 },
  { id: "a6", candidateId: "c1", jobId: "j4", stage: "offer", appliedAgo: "2 weeks ago", match: 78 },
];

export const KANBAN_STAGES = [
  { key: "new", label: "New" },
  { key: "screening", label: "Screening" },
  { key: "shortlisted", label: "Shortlisted" },
  { key: "interview", label: "Interview" },
  { key: "offer", label: "Offer" },
  { key: "hired", label: "Hired" },
];

export const TRACKER_STAGES = ["applied", "viewed", "shortlisted", "interview", "offer", "hired"];

export const CANDIDATE_APPS = [
  { jobId: "j1", stage: "shortlisted", appliedAgo: "3 days ago" },
  { jobId: "j3", stage: "viewed", appliedAgo: "5 days ago" },
  { jobId: "j4", stage: "interview", appliedAgo: "1 week ago" },
];

export const PLANS = [
  {
    key: "free",
    name: "Free",
    price: 0,
    period: "forever",
    credits: 5,
    features: ["5 profile unlocks/mo", "1 active job post", "Basic filters", "Email support"],
    cta: "Current plan",
  },
  {
    key: "pro",
    name: "Pro",
    price: 14999,
    period: "/mo",
    credits: 50,
    trial: true,
    features: ["50 profile unlocks/mo", "10 active job posts", "Advanced filters + Kanban", "Priority support", "3 team members"],
    cta: "Start 14-day trial",
    highlight: true,
  },
  {
    key: "enterprise",
    name: "Enterprise",
    price: 49999,
    period: "/mo",
    credits: 500,
    features: ["500 profile unlocks/mo", "Unlimited jobs", "SSO + audit logs", "Dedicated CSM", "Unlimited team"],
    cta: "Talk to sales",
  },
];

export const ADMIN_STATS = {
  candidates: 12480,
  employers: 342,
  companies: 289,
  activeJobs: 1156,
  applications: 24893,
  hires: 187,
  pendingVerifications: 12,
  openTickets: 4,
};

export const ADMIN_USERS = [
  { id: "u1", name: "Priya Sharma", email: "priya@acmecorp.in", role: "employer", company: "AcmeCorp", joined: "12 Jan 2026", status: "active" },
  { id: "u2", name: "Arjun Mehta", email: "arjun@example.com", role: "candidate", joined: "10 Jan 2026", status: "active" },
  { id: "u3", name: "Sneha Rao", email: "sneha@example.com", role: "candidate", joined: "9 Jan 2026", status: "active" },
  { id: "u4", name: "Kunal Deshmukh", email: "kunal@stealth.io", role: "employer", company: "Stealth.io", joined: "8 Jan 2026", status: "pending" },
  { id: "u5", name: "Rahul Iyer", email: "rahul@example.com", role: "candidate", joined: "6 Jan 2026", status: "active" },
  { id: "u6", name: "Fake User", email: "spam@throwaway.co", role: "candidate", joined: "5 Jan 2026", status: "suspended" },
];

export const ADMIN_COMPANIES = [
  { id: "co1", name: "AcmeCorp Technologies", website: "acmecorp.in", gst: "U72900MH2020PTC123456", jobs: 12, status: "verified" },
  { id: "co2", name: "Stealth.io", website: "stealth.io", gst: "U72900KA2024PTC987654", jobs: 0, status: "pending" },
  { id: "co3", name: "BrightPath EdTech", website: "brightpath.edu.in", gst: "U80300DL2022PTC456789", jobs: 4, status: "verified" },
  { id: "co4", name: "NovaHealth", website: "novahealth.co", gst: "U85110MH2023PTC112233", jobs: 2, status: "pending" },
];

export function badgeForDays(days) {
  if (days <= 15) return { color: "green", label: "Immediate / <15d" };
  if (days <= 45) return { color: "yellow", label: `${days}d notice` };
  return { color: "orange", label: `${days}d notice` };
}
